import paymentInstance from '../../../instance'
import paymentModalLoginInstance from '../../../modalLoginInstance'

const processTerminalPaymentSession = (terminalId, sessionId, hasModalLogin, data) => {
	return (hasModalLogin ? paymentModalLoginInstance : paymentInstance).post(`/terminals/${terminalId}/paymentSessions/${sessionId}/process`, data)
}

export default processTerminalPaymentSession
